import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CookieStatement from "@/pages/CookieStatement";

export const Route = createFileRoute("/en/cookie-statement")({
  head: () => buildRouteHead("/en/cookie-statement"),
  component: CookieStatement,
});

